<div class="twc-card vertical-card" *ngIf="isVertical" [ngClass]="{'dashboard': isDashboard}">
    <div class="image-container" (click)="onClickObject()">
        <ng-container *ngIf="thumbnail | async as thumbnailUrl; else imgLoading">
            <img class="position-image width-100 height-100" src="{{thumbnailUrl}}" alt="{{catalogObject.name}}">
        </ng-container>

        <div class="image-border width-100 height-100" *ngIf="checked"></div>

        <div class="width-100 height-100 image-info">
            <ng-container *ngIf="isLayer">
                <p class="layer-number twc-h4">{{projectsCount}}</p>
                <twc-icon shape="project" class="card-icon-layer"></twc-icon>
            </ng-container>
            <div *ngIf="isScan">
                <twc-icon shape="new-scanners" class="card-icon-projects"></twc-icon>
            </div>

            <ng-container *ngIf="!isDashboard">
                <p *ngIf="layerData?.incomplete || (projectData && !projectData?.available)"
                    class="incomplete-load twc-h3">
                    {{'LAYERS.UPLOADING_PENDING' | translate}}
                </p>
            </ng-container>
        </div>

    </div>

    <div class="twc-row twc-mt-3">
        <div class="twc-col cw-text-overflow-ellipsis">
            <p class="twc-card-title twc-body twc-ml-3 twc-mt-1 card-name cw-text-overflow-ellipsis"
                [ngClass]="{'twc-mr-3': isDashboard}" (click)="onClickObject()" twcTooltip="{{catalogObject.name}}"
                cwBarsTooltip>
                {{catalogObject.name}}
            </p>
        </div>

        <div class="twc-col-auto" *ngIf="!isDashboard">
            <div class="twc-row twc-mr-3 align-center">
                <div class="twc-checkbox" *ngIf="isCheckboxVisible">
                    <input class="twc-checkbox-input" type="checkbox" id="cardSelected_{{catalogObject.id}}"
                        [(ngModel)]="checked" (ngModelChange)="cardSelect(catalogObject)">
                    <label class="twc-checkbox-label" for="cardSelected_{{catalogObject.id}}"></label>
                </div>
                <twc-menu-wrapper *ngIf="cardSecondaryMenuOptions">
                    <twc-icon shape="ellipsis" class="cursor-pointer"></twc-icon>
                    <twc-menu [position]="'right'">
                        <ng-container *ngFor="let menuOption of cardSecondaryMenuOptions">
                            <twc-menu-option (click)="onSecondaryMenuClicked(menuOption)">
                                {{ menuOption.keyText| translate}}
                            </twc-menu-option>
                        </ng-container>
                    </twc-menu>
                </twc-menu-wrapper>
            </div>
        </div>
    </div>

    <ng-container *ngIf="iconDetail || projectData?.sitesCount; else noIconDetail">
        <div class="icon-detail twc-mt-1">
            <div class="icon-detail-item" *ngFor="let item of iconDetail" [twcTooltip]="item.tooltip | translate"
                placement="top">

                <twc-icon [shape]="item.icon"></twc-icon>
                <span class="twc-mt-1 twc-body">: {{item.value}}</span>
            </div>

            <div class="twc-mt-1 twc-ml-2" *ngIf="projectData?.sitesCount && isDashboard"
                [twcTooltip]="'PROJECTS.RELATED_SITES' | translate" placement="top-left">
                <twc-icon shape="dozer"></twc-icon>
                <span class="twc-mt-1 twc-body">: {{projectData?.sitesCount}}</span>
            </div>
        </div>

    </ng-container>

    <ng-template #noIconDetail>
        <div class="scroll">
            <span class="twc-small scroll-description">
                {{catalogObject.description}}
            </span>
        </div>
    </ng-template>

    <div class="create-opened-dates twc-mt-2 twc-mb-2">
        <span class="twc-small twc-ml-3 created" [style.visibility]="catalogObject.createdAt ? 'visible' : 'hidden'">
            {{'OBJECT_BROWSER.CREATED' | translate}}: {{catalogObject.createdAt | localizedDate}}
        </span>
        <span class="twc-small twc-ml-3 opened"
            [style.visibility]="accessedAt && (isDefaultProjectType || isJobSiteProject || isDashboard) ? 'visible' : 'hidden'">
            {{'OBJECT_BROWSER.OPENED' | translate}}: {{accessedAt ?? '' |localizedDate }}
        </span>
    </div>
</div>

<!-- horizontal layout -->
<div class="twc-card-horizontal horizontal-card" *ngIf="!isVertical">
    <div class="twc-row twc-no-gutters height-100 image-container" style="flex-wrap: wrap" (click)="onClickObject()">
        <ng-container *ngIf="thumbnail | async as thumbnailUrl; else imgLoading">
            <img class="position-image width-100 height-100" src="{{thumbnailUrl}}" alt="{{catalogObject.name}}">
        </ng-container>

        <div class="image-border width-100 height-100" *ngIf="checked"></div>

        <div class="width-100 height-100 image-info">
            <ng-container *ngIf="isLayer">
                <p class="layer-number twc-h4">{{projectsCount}}</p>
                <twc-icon shape="project" class="card-icon-layer"></twc-icon>
            </ng-container>
            <div *ngIf="isScan">
                <twc-icon shape="new-scanners" class="card-icon-projects"></twc-icon>
            </div>

            <ng-container *ngIf="!isDashboard">
                <p *ngIf="layerData?.incomplete || (projectData && !projectData?.available)"
                    class="incomplete-load twc-h3">
                    {{'LAYERS.UPLOADING_PENDING' | translate}}
                </p>
            </ng-container>
        </div>
    </div>

    <div class="twc-row twc-mt-3 width-100 data-container">
        <div class="twc-col width-content-70 twc-ml-3">
            <p class="twc-card-title card-name" (click)="onClickObject()">{{catalogObject.name}}</p>
            <p class="twc-small twc-mt-3 card-description">{{catalogObject.description}}</p>
            <div class="twc-mb-3" *ngIf="isProject">
                <span class="twc-row twc-mt-2 twc-ml-0">
                    <div class="twc-row twc-ml-0">
                        <p class="twc-body twc-mb-2 font-bold">{{'OBJECT_BROWSER.CREATED' | translate}}:&nbsp;</p>
                        <p class="twc-body twc-mb-2 twc-mr-4"> {{projectData?.createdAt ?? '' | localizedDate}}</p>
                    </div>
                    <p class="twc-body twc-mb-2 font-bold">{{'OBJECT_BROWSER.OPENED' | translate}}:&nbsp;</p>
                    <p class="twc-body twc-mb-2 twc-mr-4">{{projectData?.accessedAt ?? '' | localizedDate}}</p>
                    <ng-container *ngIf="projectData?.owner">
                        <p class="twc-body twc-mb-2 font-bold">{{'OBJECT_BROWSER.CREATED_BY' | translate}}:&nbsp;
                        </p>
                        <p class="twc-body twc-mb-2 twc-mr-4">{{projectData?.owner}}</p>
                    </ng-container>
                </span>
                <div class="twc-mb-2" *ngIf="projectData?.horizProjectionEPSG">
                    <span class="twc-body font-bold">{{'PROJECTS.COORDINATE' | translate}}</span>
                    <span class="twc-body twc-mr-4"> {{projectData?.horizProjectionEPSG | CRSName | async}}</span>
                </div>
                <div class="twc-mt-1" *ngIf="projectData?.sitesCount"
                    [twcTooltip]="'PROJECTS.RELATED_SITES' | translate" placement="top-left">
                    <twc-icon shape="dozer"></twc-icon>
                    <span class="twc-mt-1 twc-body">: {{projectData?.sitesCount}}</span>
                </div>
            </div>
            <cw-horizontal-layer [projectData]="projectData" [layerData]="layerData">
            </cw-horizontal-layer>
            <cw-card-horizontal-tree [projectData]="projectData"></cw-card-horizontal-tree>
        </div>

        <div class="twc-mr-3">
            <div class="twc-row align-center" *ngIf="!isDefaultProjectType || isCheckboxVisible">
                <div class="twc-checkbox">
                    <input class="twc-checkbox-input" type="checkbox" id="horizontalCard_{{catalogObject.id}}"
                        [(ngModel)]="checked" (ngModelChange)="cardSelect(catalogObject)">
                    <label class="twc-checkbox-label" for="horizontalCard_{{catalogObject.id}}"></label>
                </div>
                <twc-menu-wrapper *ngIf="cardSecondaryMenuOptions">
                    <twc-icon shape="ellipsis" class="cursor-pointer"></twc-icon>
                    <twc-menu [position]="'bottom-left'">
                        <ng-container *ngFor="let menuOption of cardSecondaryMenuOptions">
                            <twc-menu-option (click)="onSecondaryMenuClicked(menuOption)">
                                {{ menuOption.keyText| translate}}
                            </twc-menu-option>
                        </ng-container>
                    </twc-menu>
                </twc-menu-wrapper>
            </div>
        </div>
    </div>
</div>

<ng-template #imgLoading>
    <img class="position-image width-100 height-100" src="{{cardService.getDefaultThumbnail()}}"
        alt="{{catalogObject.name}}">
</ng-template>